import userAccountService from "@/services/user-account.service";
import Formatter from "@/functions/Formatter";

const state = {
  user: null,
  portfolioOwner: null,
  isToggle: null,
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
  },
  SET_USER_AVATAR(state, image) {
    state.user.avatar = image;
  },
  SET_OWNER(state, user) {
    state.portfolioOwner = user;
  },
  TOGGLE_SIDEBAR(state) {
    state.isToggle = !state.isToggle;
  },
  SET_TOGGLE_STATE(state, isToggle) {
    state.isToggle = isToggle;
  },
};

const actions = {
  async fetchUserById({ commit }, userId) {
    const response = await userAccountService.getUserByUd(userId);

    if (response.data) {
      let user = response.data;
      user.avatar = Formatter.formatImage(user.Avatar);
      commit("SET_USER", response.data);
    }
    return response;
  },
  async blockUserPortfolio({ commit, getters }, portfolioId) {
    let blockedPortfolios = getters.getBlockedPortfolios;
    blockedPortfolios.push(portfolioId);
    const response = await userAccountService.alterPortfolioBlocked(
      getters.getUser.id,
      blockedPortfolios
    );
    if (response.data) {
      response.data.avatar = Formatter.formatImage(response.data.Avatar);
      commit("SET_USER", response.data);
      return response.data;
    }
  },
  async unBlockUserPortfolio({ commit, getters }, portfolioId) {
    let blockedPortfolios = getters.getBlockedPortfolios;
    blockedPortfolios = blockedPortfolios.filter((p) => p.id !== portfolioId);
    const response = await userAccountService.alterPortfolioBlocked(
      getters.getUser.id,
      blockedPortfolios
    );
    if (response.data) {
      response.data.avatar = Formatter.formatImage(response.data.Avatar);
      commit("SET_USER", response.data);
      return response.data;
    }
  },
  async deleteUserAccount( _ , user) {
    const userId = user.id || user;
    await userAccountService.deleteUserAccount(userId);
  },
  async fetchPortfolioOwner({ commit }, user) {
    const userId = user.id || user;
    const response = await userAccountService.getUserByUd(userId);
    if (response.data) {
      const owner = response.data;
      commit("SET_OWNER", owner);
    }
  },
  async updateUserData({ commit }, data) {
    const response = await userAccountService.updateUserData(data);

    if (response.data?.status === 200) {
      response.data.avatar = Formatter.formatImage(response.data.Avatar);
      commit("SET_USER", response.data);
    }
    return response;
  },
  async updateAvatar({ commit, getters, dispatch }, image) {
    let payload = {
      refId: getters.getUser.id,
      field: "Avatar",
      ref: "user",
      image: image,
      source: "users-permissions",
    };
    const imgResponse = await dispatch("uploadImageWithRef", payload, {
      root: true,
    });
    commit("SET_USER_AVATAR", imgResponse);
  },

  clearStoredUsers({ commit }) {
    commit("SET_USER", null);
    commit("SET_OWNER", null);
  },
  async fetchToggleState({ commit }, userId) {
    const response = await userAccountService.getUserCategorySetting(userId);
    if (response.data) {
      commit("SET_TOGGLE_STATE", response.data);
      return response.data;
    }
  },
  async toggleSidebar({ commit }, userId) {
    const response = await userAccountService.getUserCategorySetting(userId);

    if (response.status === 200) {
      const toggleState = response.data;
      commit("SET_TOGGLE_STATE", !toggleState);
      const payload = {
        userId: userId,
        toggleState: !toggleState,
      };

      await userAccountService.updateUserCategorySetting(payload);
    }
  },
};

const getters = {
  getUser: (state) => {
    return state.user;
  },
  getPortfolioOwner: (state) => {
    return state.portfolioOwner;
  },
  getBlockedPortfolios: (state) => {
    return state.user.blocked_portfolios;
  },
  isToggle: (state) => state.isToggle,
  getToggleState: (state) => {
    return state.isToggle;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
